
<template>

  <div class=" employee-tab leave-attendance-dashboard">

    <div class="col-md-10 col-sm-12 pl-0" >
      <h4 class="atlhr-dashboard-title mt-10">Leave & Attendance<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Leave & Attendance / Migrated Data</span></h4>
    </div>

    <div class="mt-4 roster-wrapper">
      <b-tabs pills content-class="custom-tab-content" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white" nav-class="mb-4 mt-3 leave-attendance-dashboard-tab">

        <b-tab lazy title="Leave Past Data">
          <div class="">
            <roster-leaves-past-data></roster-leaves-past-data>
          </div>
        </b-tab>

        <b-tab lazy title="Carrying Data">
          <div class="" v-if="carry">
            <roster-carrying-data></roster-carrying-data>
          </div>
          <div v-else>
            <p>Feature Not Enabled.</p>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      carry: 0,
    }
  },
  methods: {
    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.carry = response.data.carry;
        }
      }.bind(this));
    },
  },
  created() {
    this.getCompanyLeaveSettings();
  }
}
</script>